import { connect } from 'react-redux';

import { StoreState } from '../../../reducers';
import EditableUserAvatar from '../../../components/ProfilePage/EditableUserAvatar';

const mapStateToProps = (state: StoreState) => {
	const {
		profile: {
			userAvatar: { file, isEdited },
			photoPath,
		},
	} = state;

	return {
		hasAvatar: !!file || !!photoPath,
		isEdited,
	};
};

export default connect(mapStateToProps)(EditableUserAvatar);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ProfilePage/EditableUserAvatar/index.tsx